import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { SimpleGrid, Container, Button, Text } from "@chakra-ui/react"
import UspItem from "./UspItem"
import { Icon } from "../../"

export function Usp() {
  const { dataJson } = useStaticQuery(graphql`
    query {
      dataJson {
        usp {
          icon
          heading
          body
        }
      }
    }
  `)

  return (
    <section>
      <Container pt={0}>
        <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={16}>
          {dataJson.usp.map((item, index) => (
            <UspItem key={index} {...item} />
          ))}
        </SimpleGrid>

        <Button
          as={Link}
          to={"/about"}
          alignSelf="center"
          variant="ghost"
          colorScheme="primary"
          size="sm"
          mt={12}
        >
          <Text as="span" lineHeight={1} fontSize="sm" fontWeight="bold">
            Find out more
          </Text>
          <Icon name="arrowRight" boxSize={4} ml={3} />
        </Button>
      </Container>
    </section>
  )
}
